import Ajax from '@utils/ajax';

export default {
  fetch(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/rec_requests`,
      ...options,
    });
  },

  get(token, options = {}) {
    return Ajax.get({
      url: `/rec_requests/${token}`,
      ...options,
    });
  },

  create(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_requests/`,
      data: { rec_request: data, _method: 'POST' },
      ...options,
    });
  },

  update(group, recRequest, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_requests/${recRequest.id}`,
      data: { rec_request: data, _method: 'PATCH' },
      ...options,
    });
  },

  markActive(group, recRequest, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_requests/${recRequest.id}/mark_active`,
      data: { _method: 'PATCH', rec_request: {} },
      ...options,
    });
  },

  destroy(group, recRequest, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_requests/${recRequest.id}`,
      data: { _method: 'DELETE' },
      ...options,
    });
  },

  share(group, recRequest, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_requests/${recRequest.token}/share`,
      data: data,
      ...options,
    });
  },

  responses(recRequest) {
    return Ajax.get({
      url: `/rec_requests/${recRequest.token}/rec_request_responses`,
    });
  },

  startResponse(recRequest, data, options = {}) {
    return Ajax.post({
      url: `/rec_requests/${recRequest.token}/rec_request_responses`,
      data: {
        rec_request_response: data,
      },
      ...options,
    });
  },

  submitResponse(recRequest, recRequestResponse, data, options = {}) {
    return Ajax.post({
      url: `/rec_requests/${recRequest.token}/rec_request_responses/${recRequestResponse.id}/answers`,
      data: {
        answers: data,
      },
      ...options,
    });
  },
};
